import { BridgeProxy, Platform } from 'pos/common';

type WeightStatus = { isStable: boolean, kgs: number };

export async function start(onWeightRead: (status: WeightStatus) => void): Promise<() => void> {
	if (!Platform.canUseScale())
		return async () => { };

	const refreshWeightInterval = setInterval(async () => {
		const result = await BridgeProxy.invoke('NO_REGISTER_USER_ACTIVITY', BridgeProxy.Endpoints.Scale.CurrentWeight);

		onWeightRead(result);
	}, 500);

	return function () {
		clearInterval(refreshWeightInterval);
	};
}

export async function getWeight(): Promise<{ isStable: boolean, kgs: number }> {

	// Otra opción es hacernos un Nullfingerprint
	if (!Platform.canUseScale())
		return { isStable: false, kgs: 0 };

	return await BridgeProxy.invoke('NO_REGISTER_USER_ACTIVITY', BridgeProxy.Endpoints.Scale.CurrentWeight);
}


